export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/edit.5289a529.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};